import React, {Component} from 'react';
import { Layout, Form, Input, Button, Spin } from 'antd';
import axios from 'axios';
import queryString from 'query-string';
import jwtDecode from 'jwt-decode';

import { Constant } from '../../config';
import MyModal from '../Modal';

const { Content } = Layout

class InviteAdmin extends Component {
	state = {
		loading: false,
		errTxt: "",
		firstErr: "",
	}

	inviteToken = ""

	componentWillMount() {
		if (localStorage.getItem(Constant.SessionKey)) {
			this.props.history.push('/')
			return
		}

		const params = queryString.parse(this.props.location.search)
		if (!params.token) {
			this.setState({firstErr: "[1] URL ของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง"})
			return
		}

		let exp = 0
		try {
			let tmp = jwtDecode(params.token)	
			exp = tmp.exp
		} catch(err) {
			this.setState({firstErr: "[2] URL ของคุณไม่ถูกต้อง กรุณาตรวจสอบและลองใหม่อีกครั้ง"})
			return
		}

		if (exp && Date.now() > exp * 1000) {
			this.setState({firstErr: "Token หมดอายุ กรุณาติดต่อผู้ดูแลระบบ"})
			return
		}

		this.inviteToken = params.token
	}

	handleSubmit = e => {
		e.preventDefault();

		this.props.form.validateFields(async (err, values) => {
			if (err) 
      	return

      this.setState({ 
				loading: true,
				errTxt: "",
			})

      let opt = {
      	url: Constant.ADMIN_SET_PASSWORD,
      	data: queryString.stringify(values),
      	method: "POST",
      	headers: {
      		'Authorization': "Bearer "+this.inviteToken,
      		'Content-Type': 'application/x-www-form-urlencoded'
      	}
      }
      let resp
      let eMsg = "เกิดข้อผิดพลาด ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง"
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch(err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsg = `[${e.code}] ${eMsg}`
      }

      if (eFlag) {
        this.setState({
      		loading: false,
      		errTxt: eMsg
      	})
      } else {
      	MyModal.info("บันทึกข้อมูลสำเร็จ", "", ()=>{
      		this.props.history.push('/')
      	})
      }
		});
	}

	render() {
		const { getFieldDecorator } = this.props.form;

		return (
			<Content className="signin-form">
				{this.state.firstErr!== "" ? 
					<h1>{this.state.firstErr}</h1>
				:
					<Spin spinning={this.state.loading} tip="กำลังบันทึกข้อมูล...">
						<Form onSubmit={this.handleSubmit}>
							<Form.Item>
								{getFieldDecorator('password', {
									rules: [
			              {
			                required: true,
			                min: 8,
			                max: 16,
			                message: 'กรุณากรอกรหัสผ่าน 8-16 ตัวอักษร',
			              },
			            ],
								})(
									<Input 
										type="password"
										placeholder="รหัสผ่าน"
									/>
								)}
							</Form.Item>
							<Form.Item>
								{getFieldDecorator('confirm_password', {
									rules: [
			              {
			                required: true,
			                min: 8,
			                max: 16,
			                message: 'กรุณากรอกรหัสผ่าน 8-16 ตัวอักษร',
			              },
			            ],
								})(
									<Input 
										type="password"
										placeholder="ยืนยันรหัสผ่าน"
									/>
								)}
							</Form.Item>

				      <Form.Item>
				        <Button type="primary" htmlType="submit" className="signin-form-button">
				          ตกลง
				        </Button>
				      </Form.Item>
				      <Form.Item>
				      	<span>{this.state.errTxt}</span>
				      </Form.Item>
						</Form>
					</Spin>
				}
	    </Content>
		)
	}
}

const InviteAdminForm = Form.create({name:'invite_admin_form'})(InviteAdmin)

export default InviteAdminForm


// WEBPACK FOOTER //
// ./src/containers/InviteAdmin/index.js